"use strict";

var _PageTransition = _interopRequireDefault(require("./PageTransition"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  PageTransition: _PageTransition.default
};